// Alerts
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

// Breadcrumb
export const EDITAR_BREADCRUMB = 'EDITAR_BREADCRUMB';

// Loader
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';

// Auth
export const LOGIN = 'LOGIN';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const OBTENER_USUARIO = 'OBTENER_USUARIO';
export const OBTENER_USUARIO_ERROR = 'OBTENER_USUARIO_ERROR';
export const LOGOUT = 'LOGOUT';
export const RECUPERAR_USUARIO = 'RECUPERAR_USUARIO';
export const RESTABLECER_USUARIO = 'RESTABLECER_USUARIO';

// Dashboard
export const DASHBOARD = {
    OBTENER: 'OBTENER_DASHBOARD'
};

// Clientes
export const CLIENTES = {
    BUSCAR: 'BUSCAR_CLIENTES',
    BUSCAR_AVANZADO: 'BUSCAR_CLIENTES_EMPRESAS',
    DETALLES: 'DETALLES_CLIENTE',
    MEMBRESIA: 'MEMBRESIA_CLIENTE',
    MEMBRESIAS: 'MEMBRESIAS_CLIENTE',
    DESACTIVAR_RENOVACION: 'DESACTIVAR_RENOVACION_CLIENTE',
    ELIMINAR: 'ELIMINAR_CLIENTE',
    FILTROS: 'FILTRAR_CLIENTES',
    ARCHIVOS: {
        LISTAR: 'LISTAR_ARCHIVOS_CLIENTE',
        DETALLES: 'DETALLES_ARCHIVO_CLIENTE'
    }
};

// Solicitudes WhatsApp
export const SOLICITUDES_WA = {
    BUSCAR:    'BUSCAR_SOLICITUDES_WA',
    DETALLES:  'DETALLES_SOLICITUD_WA',
    ASIGNAR:   'ASIGNAR_SOLICITUD_WA',
    STATUS:    'STATUS_SOLICITUD_WA',
    CONVERTIR: 'CONVERTIR_SOLICITUD_WA',
    ELIMINAR:  'ELIMINAR_SOLICITUD_WA'
};

// Asesorias
export const ASESORIAS = {
    BUSCAR: 'BUSCAR_ASESORIAS',
    DETALLES: 'DETALLES_ASESORIA',
    STATUS: 'STATUS_ASESORIA',
    ASIGNAR: 'ASIGNAR_ASESORIA',
    ELIMINAR: 'ELIMINAR_ASESORIA',
    FILTROS: 'FILTRAR_ASESORIAS', 
    CONTACTOS: {
        LISTAR: 'LISTAR_CONTACTOS_ASESORIA', 
        DETALLES: 'DETALLES_CONTACTO_ASESORIA'
    }, 
    NOTAS: {
        LISTAR: 'LISTAR_NOTAS_ASESORIA', 
        DETALLES: 'DETALLES_NOTA_ASESORIA'
    }, 
    ARCHIVOS: {
        LISTAR: 'LISTAR_ARCHIVOS_ASESORIA',
        DETALLES: 'DETALLES_ARCHIVO_ASESORIA'
    },
    AHORROS: {
        LISTAR: 'LISTAR_AHORROS_ASESORIA',
        DETALLES: 'DETALLES_AHORRO_ASESORIA'
    }
};

// Usuarios
export const USUARIO = {
    BUSCAR: 'BUSCAR_USUARIOS', 
    AGREGAR: 'AGREGAR_USUARIO', 
    DETALLES: 'DETALLES_USUARIO', 
    EDITAR: 'EDITAR_USUARIO', 
    ELIMINAR: 'ELIMINAR_USUARIO', 
    FILTROS: 'FILTRAR_USUARIOS'
};

// Citas
export const CITAS = {
    BUSCAR: 'BUSCAR_CITAS', 
    BUSCAR_HORARIOS: 'BUSCAR_HORARIOS', 
    AGREGAR: 'AGREGAR_CITA', 
    DETALLES: 'DETALLES_CITA', 
    EDITAR: 'EDITAR_CITA', 
    ELIMINAR: 'ELIMINAR_CITA', 
    FILTROS: 'FILTRAR_RESERVACIONES'
};

// Reportes
export const REPORTES = {
    BUSCAR_REQUERIMIENTOS: 'BUSCAR_REQUERIMIENTOS_REPORTES'
};

// Configuración
export const CONFIGURACION_MEMBRESIAS = {
    BUSCAR: 'BUSCAR_MEMBRESIAS', 
    AGREGAR: 'AGREGAR_MEMBRESIA', 
    DETALLES: 'DETALLES_MEMBRESIA', 
    EDITAR: 'EDITAR_MEMBRESIA', 
    ELIMINAR: 'ELIMINAR_MEMBRESIA'
};

export const CONFIGURACION_REGIMENES_FISCALES = {
    BUSCAR: 'BUSCAR_REGIMENES_FISCALES', 
    AGREGAR: 'AGREGAR_REGIMEN_FISCAL', 
    DETALLES: 'DETALLES_REGIMEN_FISCAL', 
    EDITAR: 'EDITAR_REGIMEN_FISCAL', 
    ELIMINAR: 'ELIMINAR_REGIMEN_FISCAL'
};

export const CONFIGURACION_GIROS = {
    BUSCAR: 'BUSCAR_GIROS', 
    AGREGAR: 'AGREGAR_GIRO', 
    DETALLES: 'DETALLES_GIRO', 
    EDITAR: 'EDITAR_GIRO', 
    ELIMINAR: 'ELIMINAR_GIRO'
};

export const CONFIGURACION_PERFIL = {
    EDITAR_PERSONAL: 'EDITAR_PERFIL_PERSONAL', 
    EDITAR_EMPRESARIAL: 'EDITAR_PERFIL_EMPRESARIAL'
};